import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-chip',
  styleUrls: ['./chip.component.scss'],
  templateUrl: './chip.component.html',
})
export class ChipComponent {
  @Input() data: any[];
  @Input() exactMatch = false;
  @Input() multiselect = false;
  @Input() selected: any[] = [];
  @Input() size: number = 1;
  @Input() translationPrefix: string = '';

  @Output() itemChanged: EventEmitter<string[]> = new EventEmitter();

  constructor(private translateService: TranslateService) {}

  get disabledChipMessage(): string {
    return this.translateService.instant(
      'EDITION.SLOPE-EDITOR.options.default-active'
    );
  }

  ifSelected(item: any): boolean {
    if (this.multiselect) {
      for (const element of this.selected) {
        if (element.id === item.id) {
          return true;
        }
      }
      return false;
    } else {
      if (this.exactMatch) {
        return this.selected === item;
      }
      return this.selected.includes(item) ? true : false;
    }
  }

  selectItem(item: any): void {
    if (item.active === false) return;

    if (this.multiselect) {
      if (this.selected.filter((e) => e.id === item.id).length) {
        for (let index = 0; index < this.selected.length; index++) {
          if (this.selected[index].id === item.id) {
            this.selected.splice(index, 1);
          }
        }
      } else {
        this.selected.push(item);
      }
      this.itemChanged.emit(this.selected);
    } else {
      this.itemChanged.emit([item]);
    }
  }
}
